import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { sendSubmission } from '../../actions/sendSubmission'
import { useModal } from '../../hooks/useModal'
import { selectFormActionLoading } from '../../redux/formState/selectors'
import { useAppDispatch } from '../../redux/store'
import ButtonGov from '../Btns/ButtonGov'
import Loading from '../Loading/Loading'

const ModalConfirmSubmit = () => {
  const dispatch = useAppDispatch()
  const { closeModal } = useModal()
  const actionLoading = useSelector(selectFormActionLoading)
  const [done, setDone] = useState(false)

  const clickOk = () => {
    dispatch(sendSubmission())
    setDone(true)
  }

  useEffect(() => {
    if (done && !actionLoading) {
      closeModal()
    }
  }, [done, actionLoading])

  const clickCancel = () => {
    closeModal()
  }

  if (actionLoading) {
    return (
      <>
        Formulář se odesílá.
        <Loading />
      </>
    )
  }

  return (
    <>
      <div className='u-mb--50'>Opravdu chcete podat formulář?</div>

      <ButtonGov variant='primary' className='u-me--20' onClick={clickOk}>
        Podat
      </ButtonGov>

      <ButtonGov variant='primary-outlined' onClick={clickCancel}>
        Zrušit
      </ButtonGov>
    </>
  )
}

export default ModalConfirmSubmit
